export const Colors = {
  black: "#000",
  white: "#fff",
  gold300: "#D0BA92",
  gray100: "#E6E4E4",
  gray150: "#CCCACA",
  gray200: "#B3AFAF",
  gray250: "#807C7C",
  gray300: "#333333",
  gray400: "#1A1717",
  error: "#f73e09",
  red400: "##DD4C28",
  gold: "#D0BA92",
}

export const Spacing = {
  s1: 8,
  s2: 16,
  s3: 24,
  s4: 32,
  s5: 40,
  s6: 48,
  s7: 56,
  s8: 64,
  s9: 72,
  s10: 80,
}

export const FontWeight = {
  medium: 300,
  normal: "normal",
  bold: "bold",
}

export const FontFamily = {
  serif: "William Regular",
  serifItalic: "William Regular Italic",
  serifDisplay: "William Display",
  sansSerif: "Figgins Sans",
  sansSerifBold: "Figgins Sans Bold",
}

export const BreakPoints = Object.freeze({
  laptop: 1280 as 1280,
  large_desktop: 1440 as 1440,
  desktop: 1024 as 1024,
  tablet: 768 as 768,
  xs_mobile: 375 as 375,
  small: 640 as 640,
  medium: 1007 as 1007,
  large: 1008 as 1008,
  laptop_small: 1024 as 1024,
})

export const ViewPorts = {
  laptop: `@media only screen and (min-width: ${
    BreakPoints.laptop
  }px) and (max-width: ${BreakPoints.large_desktop - 1}px)`,
  large_desktop: `@media only screen and (min-width: ${BreakPoints.large_desktop}px)`,
  desktop: `@media only screen and (min-width: ${BreakPoints.laptop}px)`,
  desktop_new: `@media only screen and (min-width: ${BreakPoints.desktop}px)`,
  touch: `@media only screen and (max-width: ${BreakPoints.laptop - 1}px)`,
  tablet: `@media only screen and (min-width: ${
    BreakPoints.tablet
  }px) and (max-width: ${BreakPoints.laptop - 1}px)`,
  mobile: `@media only screen and (max-width: ${BreakPoints.tablet - 1}px)`,
  laptop_small: `@media only screen and (min-width: ${
    BreakPoints.laptop_small
  }px) and (max-width: ${BreakPoints.laptop - 1}px)`,
  tablet_new: `@media only screen and (min-width: ${
    BreakPoints.tablet
  }px) and (max-width: ${BreakPoints.laptop_small - 1}px)`,
}

export type TColorsUnion = keyof typeof Colors
export type TColor = string | TColorsUnion

export type TSpacingUnion = keyof typeof Spacing
export type TUnit = number | string | TSpacingUnion
export type TFontWeightUnion = keyof typeof FontWeight
export type TFontFamilyUnion = keyof typeof FontFamily
export type TBreakPointsUnion = keyof typeof BreakPoints
export type TViewPortsUnion = keyof typeof ViewPorts

export interface Theme {
  Spacing: typeof Spacing
  FontWeight: typeof FontWeight
  FontFamily: typeof FontFamily
  BreakPoints: typeof BreakPoints
  ViewPorts: typeof ViewPorts
  Colors: typeof Colors
}

export const theme = {
  Spacing,
  FontWeight,
  FontFamily,
  BreakPoints,
  ViewPorts,
  Colors,
} as Theme

export interface WithTheme {
  theme: Theme
}
